export { VaTableSortService, SortSetting } from './va-table-sort.service';
